export default function fromSmoochMessage(message) {
  let content;
  if (message.type === 'text') {
    content = { body: message.text };
  } else if (message.type === 'image' || message.type === 'file') {
    content = { fileName: message.metadata.fileName, mediaUrl: message.mediaUrl };
  } else {
    return;
  }

  return {
    id: message.metadata.internalId || message._id,
    content,
    date: new Date(message.received * 1000),
    isUser: message.role === 'appUser',
    subType: message.metadata.subType,
    // initial states; errors are added by createMessage.js if an error comes in
    _isSending: false,
    _hasError: false,
    _errors: [],
  };
}
